


import React, { useState } from "react";

const gallery = [
  {
    image: "/images/Fleet/dzire.jpg",
    title: "dzire",
  },
  {
    image: "/images/Fleet/ertiga.jpg",
    title: "ertiga",
  },
  {
    image: "/images/Fleet/rumion.jpg",
    title: "rumion",
  },
  {
    image: "/images/Fleet/Innova-Crysta.jpg",
    title: "Innova-Crysta",
  },
  {
    image: "/images/Fleet/Innova-hycross.jpg",
    title: "Innova-hycross",
  },
  {
    image: "/images/Fleet/kia.jpg",
    title: "kia",
  },
  {
    image: "/images/Fleet/trmpo-traveller.jpg",
    title: "trmpo-traveller",
  },
  {
    image: "/images/Fleet/Urbania-Bus.jpg",
    title: "Urbania-Bus",
  },
  {
    image: "/images/Fleet/mini-bus.jpg",
    title: "mini-bus",
  },
];

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openImage = (index) => {
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === gallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? gallery.length - 1 : prev - 1
    );
  };

  return (
    <>
       

 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Gallery
        </h2>
      </div>
    </section>
    


      <div className="container py-5">
        <div className="row">
          {gallery.map((item, index) => (
          
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
  <div className="fleetCard" onClick={() => openImage(index)}>

    <div className="fleetBadge">
      Sai Shirdi Cabs
    </div>

    <div className="fleetImage">
      <img src={item.image} alt={item.name} />
    </div>

    <div className="fleetContent">
      <h4>{item.name}</h4>

      <div className="fleetBottom">
        <span>Comfort Ride</span>

        <button>
          View
          <i className="fas fa-arrow-right"></i>
        </button>
      </div>
    </div>

  </div>
</div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox">
          <span className="close darkcolorrrr" onClick={closeImage}>✖</span>

          <span className="prev" onClick={prevImage}>❮</span>
          <img
            src={gallery[currentIndex].image}
            alt="preview"
            className="lightbox-img "
          />
          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </>
  );
};

export default Gallery;